import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative animate-shimmer overflow-hidden rounded-md bg-muted/60 bg-shimmer-gradient",
        "[background-repeat:no-repeat] [background-size:200%_100%]",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
